/**
 * Auto-generated i18n keys.
 * DO NOT EDIT THIS FILE MANUALLY.
 */

type TranslationKey<TRANSLATED> = { key: string; _translated?: TRANSLATED };
type TranslationKeyFn<P extends Record<string, any>, TRANSLATED> = (params: P) => {
  key: string;
  params: P;
  _translated: TRANSLATED;
};

export const keys = {
  commonFrontend: {
    misc: {
      noResult: { key: "commonFrontend.misc.noResult" } as TranslationKey<"Aucun résultat">,
      other: { key: "commonFrontend.misc.other" } as TranslationKey<"Autre">,
    },
    "site-tree-structure": {
      title: { key: "commonFrontend.site-tree-structure.title" } as TranslationKey<"Structure du site">,
      searchSection: { key: "commonFrontend.site-tree-structure.searchSection" } as TranslationKey<"Rechercher un espace">,
    },
    "site-sections-tree": {
      "appliance-count": ((params: { count: number }) => ({ key: "commonFrontend.site-sections-tree.appliance-count", params })) as TranslationKeyFn<{ count: number }, "Aucun équipement | 1 équipement | {count} équipements">,
      "section-appliances": {
        title: { key: "commonFrontend.site-sections-tree.section-appliances.title" } as TranslationKey<"Équipements">,
        "move-appliances": { key: "commonFrontend.site-sections-tree.section-appliances.move-appliances" } as TranslationKey<"Déplacer des équipements">,
        "see-all": ((params: { count: number }) => ({ key: "commonFrontend.site-sections-tree.section-appliances.see-all", params })) as TranslationKeyFn<{ count: number }, "Voir tous les équipements ({count})">,
      },
    },
    applianceCategory: {
      HEATER: { key: "commonFrontend.applianceCategory.HEATER" } as TranslationKey<"Chauffage">,
      AC_UNIT_NON_INFRARED: { key: "commonFrontend.applianceCategory.AC_UNIT_NON_INFRARED" } as TranslationKey<"Climatisation">,
      WATER_HEATER: { key: "commonFrontend.applianceCategory.WATER_HEATER" } as TranslationKey<"Chauffe-eau">,
    },
  },
} as const;

